// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Glyphicon } from 'react-bootstrap';

export default class PlacesElement extends React.PureComponent {
  deletePlace = event => {
    event.stopPropagation();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    actions.deletePlace(
      event.currentTarget.getAttribute('data-name'),
      'articles'
    );
  };

  updatePlace = event => {
    event.stopPropagation();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    actions.updatePlace(
      event.currentTarget.getAttribute('data-name'),
      'articles'
    );
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { value, ind } = this.props;
    return (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      <tr key={value.title} data-name={ind} className='listrow moveable'>
        <td style={{ verticalAlign: 'middle' }}>
          <Glyphicon glyph='option-vertical' />
        </td>
        <td
          style={{ maxWidth: '200px', verticalAlign: 'middle' }}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          title={value.title}
        >
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          <span className='big-text-field'>{value.title}</span>
        </td>
        <td
          style={{
            width: '5%',
            textAlign: 'center',
            verticalAlign: 'middle',
            cursor: 'pointer',
          }}
        >
          <i
            className='fas fa-pen'
            data-name={ind}
            onClick={this.updatePlace}
            style={{ marginRight: '10px' }}
          />
          <i
            className='fas fa-times'
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            // eslint-disable-next-line react/no-unknown-property
            glyph='remove'
            data-name={ind}
            onClick={this.deletePlace}
          />
        </td>
      </tr>
    );
  }
}
